import React, { useEffect, useState } from "react";
import { Button, Table, Input, Tooltip, Breadcrumb, Select } from "antd";
import { toast } from "react-toastify";
import { HomeOutlined } from "@ant-design/icons";
import AjouterOffre from "./modals/AjouterOffre";
import {
  fatchOffers,
  getAllTypeOffers,
  deleteOffer,
} from "../../../../services/offers/offersApi";
import { formateCoins, promotion } from "../../../../function";
import EditOffre from "./modals/EditOffre";
import ConfirmationModal from "./modals/ConfirmationModal";

const Offers = () => {
  const { Option } = Select;
  const [offers, setOffers] = useState([]);
  const [search, setSearch] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [totalRows, setTotalRows] = useState(0);
  const [perPage] = useState(10);
  const [isOpenAddModal, setIsOpenAddModal] = useState(false);
  const [isOpenEditModal, setIsOpenEditModal] = useState(false);
  const [offerToEdit, setOfferToEdit] = useState(null);
  const [isOpenConfirmDelete, setIsOpenConfirmDelete] = useState(false);
  const [offerToDelete, setOfferToDelete] = useState(null);
  const [typeOffers, setTypeOffers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedType, setSelectedType] = useState("");

  useEffect(() => {
    loadOffers();
    fetchTypeOffers();
  }, [search, currentPage, selectedType]);

  const fetchTypeOffers = async () => {
    try {
      const response = await getAllTypeOffers();
      setTypeOffers(response.data);
    } catch (error) {
      toast.error("Failed to fetch type offers");
    }
  };

  const loadOffers = () => {
    fatchOffers(search, perPage, currentPage, selectedType)
      .then((response) => {
        setOffers(response.data.offres);
        setTotalRows(response.data.totalRows);
        setLoading(false);
      })
      .catch((error) => {
        toast.error("Error fetching offers.");
        setLoading(false);
      });
  };

  const handleAddOffer = () => {
    loadOffers();
  };

  const handleDeleteOffer = () => {
    if (offerToDelete) {
      deleteOffer(offerToDelete.id)
        .then(() => {
          toast.success("Offer deleted successfully!");
          loadOffers();
          setIsOpenConfirmDelete(false);
        })
        .catch((error) => {
          toast.error("Error deleting offer.");
        });
    }
  };

 const columns = [
  {
    title: "Coins",
    dataIndex: "coins",
    key: "coins",
    render: (text) => <span>{formateCoins(text)}</span>,
  },
  {
    title: "Montant Original",
    dataIndex: "montant",
    key: "montant",
    render: (text, record) => (
      <span style={{ fontWeight: "bold", color: "var(--primary-color)" }}>
        {text} USD
      </span>
    ),
  },
  {
    title: "Montant Avant Promotion",
    dataIndex: "montant_promotion", // Supposons que ce champ existe dans votre base de données
    key: "montant_promotion",
    render: (text, record) => {
      // Si vous avez un champ séparé pour le montant avant promotion
      if (record.montant_promotion) {
        return (
          <div>
            <span style={{ fontWeight: "bold", color: "var(--primary-color3)" }}>
              {record.montant_promotion} USD
            </span>
            {record.promotion > 0 && (
              <span style={{ textDecoration: "line-through", color: "var(--primary-color5)", marginLeft: "8px" }}>
                {record.montant_promotion} USD
              </span>
            )}
          </div>
        );
      }
      
      // Si vous calculez le montant avant promotion à partir du montant actuel et de la promotion
      if (record.promotion > 0) {
        const montantAvantPromotion = record.montant / (1 - record.promotion / 100);
        return (
          <div>
            <span style={{ fontWeight: "bold", color: "var(--primary-color3)" }}>
              {Math.round(montantAvantPromotion)} USD
            </span>
            <span style={{ textDecoration: "line-through", color: "var(--primary-color5)", marginLeft: "8px" }}>
              {Math.round(montantAvantPromotion)} USD
            </span>
          </div>
        );
      }
      
      return (
        <span style={{ color: "var(--primary-color5)" }}>
          Pas de promotion
        </span>
      );
    },
  },
  {
    title: "Promotion",
    dataIndex: "promotion",
    key: "promotion",
    render: (text) =>
      text !== null &&
      text > 0 && (
        <div
          className="badge badge-promotion"
          style={{
            backgroundColor: "#ff4d4f",
            color: "white",
            textAlign: "center",
            width: "50px",
            borderRadius: "4px",
            padding: "2px 8px",
          }}
        >
          {text}%
        </div>
      ),
  },
  {
    title: "Type",
    dataIndex: "type_id",
    key: "type_id",
    render: (text) => (
      <span>{typeOffers.find((t) => t.id == text)?.nom ?? ""}</span>
    ),
  },
  {
    title: "Actions",
    dataIndex: "actions",
    key: "actions",
    render: (text, offer) => (
      <span>
        <Tooltip title="Edit">
          <Button
            shape="circle"
            onClick={() => {
              setOfferToEdit(offer);
              setIsOpenEditModal(true);
            }}
            icon={<i className="bi bi-pencil-square"></i>}
          />
        </Tooltip>
        <Tooltip title="Delete">
          <Button
            danger
            shape="circle"
            onClick={() => {
              setOfferToDelete(offer);
              setIsOpenConfirmDelete(true);
            }}
            icon={<i className="bi bi-trash"></i>}
          />
        </Tooltip>
      </span>
    ),
  },
];

  return (
    <>
      <div>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <h4 className="col-lg-11">
            <div className="mb-2">
              <i
                className="bx bx-tag me-2"
                style={{ color: "var(--primary-color3) !important" }}
              />
              <h3 style={{ color: "var(--primary-color3) !important" }}>
                offers
              </h3>
            </div>
            <Breadcrumb>
              <Breadcrumb.Item>
                <HomeOutlined />
              </Breadcrumb.Item>
              <Breadcrumb.Item
                style={{ color: "var(--primary-color3) !important" }}
              >
                offers
              </Breadcrumb.Item>
            </Breadcrumb>
          </h4>
          <Button
            onClick={() => setIsOpenAddModal(true)}
            style={{ backgroundColor: "var(--primary-color5)", color: "white" }}
          >
            <span>Ajouter</span>
          </Button>
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            margin: "10px 0",
          }}
        >
          <div style={{paddingBottom:"10px",paddingRight:"10px"}}>
            <Select
              value={selectedType}
              onChange={(value) => setSelectedType(value)}
              placeholder="Select Type"
            >
              <Option value="">Select Type</Option>
              {typeOffers.map((offer) => (
                <Option key={offer.id} value={offer.id}>
                  {offer.nom}
                </Option>
              ))}
            </Select>
          </div>
          <Input
            onChange={(e) => setSearch(e.target.value)}
            placeholder="Rechercher"
            value={search}
            suffix={<i className="bi bi-search" />}
            style={{ width: "200px" }}
          />
        </div>
        <Table
          dataSource={offers}
          columns={columns}
          pagination={{
            current: currentPage,
            total: totalRows,
            pageSize: perPage,
            onChange: setCurrentPage,
          }}
          loading={loading}
          scroll={{ x: 1000 }}
        />

        <AjouterOffre
          isOpen={isOpenAddModal}
          onClose={() => setIsOpenAddModal(false)}
          onSubmit={handleAddOffer}
        />

        <EditOffre
          isOpen={isOpenEditModal}
          onClose={() => setIsOpenEditModal(false)}
          onSubmit={loadOffers}
          offer={offerToEdit}
        />

        <ConfirmationModal
          isOpen={isOpenConfirmDelete}
          onClose={() => setIsOpenConfirmDelete(false)}
          onConfirm={handleDeleteOffer}
        />
      </div>
    </>
  );
};

export default Offers;